import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  dropDownMenuContainer: {
    '& > button': {
      background: 'transparent',
      '& svg': {
        display: 'inline-block',
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        verticalAlign: 'sub',
        fontSize: '130%'
      },
      '&:hover': {
        background: 'transparent'
      }
    }
  },
  list: {
    '& div': {
      boxShadow: '0px 6px 12px 1px rgba(0,0,0,0.08)',
      '& > ul': {
        borderRadius: 3,
        padding: 10,
        '& li > div': {
          boxShadow: 'none'
        },
      }
    }
  },
  item: {
    color: '#4a4a4a',
    fontWeight: 500,
    alignItems: 'center',
    lineHeight: 1,
    padding: 6,
    borderRadius: 3,
    minWidth: 150,
    marginBottom: 3,
    display: 'block',
    '&:last-child': {
      marginBottom: 0,
    },
    '&:hover': {
      color: '#fff',
      background: theme.palette.primary.main,
      '& a': {
        color: '#ffffff',
      }
    },
    '& svg, & img': {
      pointerEvents: 'none'
    },
    '& a': {
      color: '#4a4a4a',
      textDecoration: 'none',
      '& > span': {
        display: 'block'
      },
      '&:hover': {
        color: '#ffffff',
      }
    }
  },
  downloadIcon: {
    marginRight: '6px',
  },
  arrowIcon: {
    marginLeft: '6px',
  }
});